import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router';
import LoadingSpin from '../../loadingSpin/LoadingSpin';
import { Card, Col, Divider, Form, Input, message, notification, Row, Space, Table, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

import GetBinService from '../../../services/Wash-service/GetBinService';
import garment_img from '../../../assets/dashboard/garment_img.png'
import ResponseMessage from '../../Comman/Notification/ResponseMessge';

const BinTransitKanbanView = ({handleArrowClick}) => {

    const location = useLocation();
    const navigate = useNavigate();
    const [api, contextHolder] = notification.useNotification();

    const [binData, setBinData] = useState();
    const [binId, setBinId] = useState();
    const [isLoading, setIsLoading] = useState();
    const [displayGarment, setDisplayGarment] = useState([]);

    function openNotificationWithIcon(type, title, description) {
        api[type]({
            message: title,
            description,
        });
    }

    useEffect(() => {
        const fetchKanbanData = async () => {
            const queryParams = new URLSearchParams(location.search);
            const bin_id = queryParams.get('binId');

            console.log(bin_id);

            setBinId(bin_id);

            if (!bin_id) {
                ResponseMessage.error({ message : "No Bin ID provided."});
                return;
            }

            setIsLoading(true);
            try {
                const response = await GetBinService.ViewBinbyId(bin_id);

                const data = response.data;

                const transformedData = data.flatMap((item) => {
                    const sizeQty = JSON.parse(item.size_qty);
                    return Object.entries(sizeQty)
                        .filter(([size, qty]) => qty)
                        .map(([size, qty]) => ({
                            kanban_no: item.kanban_no,
                            size,
                            qty: Number(qty),
                        }));
                });

                const transformedDataWithId = transformedData.map((item, index) => ({
                    ...item,
                    id: index + 1, // Non-repeated series number starting from 1
                }));

                // setDisplayGarment(transformedDataWithId);
                console.log(response.data);

                if (Array.isArray(response.data) && response.data.length > 0) {
                    setDisplayGarment(response.data);
                } else {
                    openNotificationWithIcon('warning', 'No Data Found', response.message || 'No Bin data available.');
                    handleArrowClick();
                }
            } catch (error) {
                console.error(error);
                openNotificationWithIcon('error', 'Error', 'An error occurred while fetching data.');
                handleArrowClick();
            } finally {
                setIsLoading(false);
            }
        };

        fetchKanbanData();
    }, [location]);

    const aggregatedSizes = displayGarment.reduce((acc, garment) => {
        const sizeData = JSON.parse(garment.size_qty);
        Object.keys(sizeData).forEach((size) => {
            const qty = Number(sizeData[size]);
            if (qty > 0) {
                acc[size] = (acc[size] || 0) + qty;
            }
        });
        return acc;
    }, {});

    const totalQuantity = Object.values(aggregatedSizes).reduce(
        (sum, qty) => sum + qty,
        0
    );

    const formText = {
        inputStyle: {
            color: 'black',
            fontWeight: 'bold'
        }
    };
    return (
        <>
            {contextHolder}
            {isLoading && <LoadingSpin />}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                        fontSize: 'inherit', // Use inherit to maintain the parent font size
                    }}
                >
                    <ArrowLeftOutlined onClick={handleArrowClick} style={{ paddingRight: '10px' }} />
                    <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Bin {binId}</span>
                </Typography.Title>
                <p
                    style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                    }}
                >
                    Total Quantity: {totalQuantity}
                </p>
            </div>
            <Divider style={{ marginTop: 5 }} />

            <div>
                <>
                    <div style={{
                        maxWidth: "100%",
                        paddingBottom: '20px',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        flexDirection: 'column'
                    }}>

                        {/* Inline display of sizes with gap */}
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "16px", // Gap between items
                            }}
                        >
                            {Object.entries(aggregatedSizes).map(([size, totalQty]) => (
                                <p
                                    key={size}
                                    style={{
                                        fontSize: "16px",
                                        margin: 0,
                                        padding: "8px 16px",
                                        border: "1px solid #ddd",
                                        borderRadius: "8px",
                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                    }}
                                >
                                    <strong>{size}:</strong> {totalQty}
                                </p>
                            ))}
                        </div>
                    </div>

                </>
                {displayGarment.length > 0 ? (
                    <Row gutter={[16, 16]}>
                        {displayGarment.map((garment) => {
                            const sizeData = JSON.parse(garment.size_qty);

                            const filteredSizeData = Object.keys(sizeData)
                                .filter((size) => sizeData[size] && Number(sizeData[size]) > 0)
                                .reduce((acc, size) => {
                                    acc[size] = sizeData[size];
                                    return acc;
                                }, {});

                            const sizeColumns = Object.keys(filteredSizeData).map((size) => ({
                                title: size,
                                dataIndex: size,
                                key: size,
                                render: (text) => <strong>{text}</strong>,
                            }));

                            return (
                                <Col xs={24} sm={12} lg={8} key={garment.dbd_id}>
                                    <Card title={
                                        <>
                                            Kanban No: <span style={formText.inputStyle}>{garment.kanban_no}</span>
                                        </>
                                    }
                                        size='small'
                                        bordered>
                                        <div style={{ textAlign: 'center' }}>
                                            <img
                                                src={garment_img}
                                                alt="Garment"
                                                style={{ width: '40%', height: '40%', objectFit: 'cover' }}
                                            />
                                        </div>
                                        <div style={{ maxWidth: 300 }}>
                                            <Space direction="vertical" size="small" style={{ width: '100%' }}>
                                                <Form.Item label="Item No" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                                    <Input value={garment.item_no} disabled
                                                        style={formText.inputStyle} />
                                                </Form.Item>
                                                <Form.Item label="PO No" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                                    <Input value={garment.po_no} disabled
                                                        style={formText.inputStyle} />
                                                </Form.Item>
                                                <Form.Item label="Country" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                                    <Input value={garment.country || `No Data`} disabled
                                                        style={formText.inputStyle} />
                                                </Form.Item>
                                                <Form.Item label="Total Qty" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                                    <Input value={garment.total_qty} disabled
                                                        style={formText.inputStyle} />
                                                </Form.Item>
                                                <Form.Item label="Color" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                                    <Input value={garment.color} disabled
                                                        style={formText.inputStyle} />
                                                </Form.Item>
                                            </Space>
                                        </div>

                                        <Table
                                            size='small'
                                            columns={sizeColumns}
                                            dataSource={[filteredSizeData]}
                                            pagination={false}
                                            bordered
                                            rowKey={() => garment.dbd_id}
                                        />

                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                ) : (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px', color: 'gray' }}>
                        <p>No data found</p>
                    </div>
                )}
            </div >
        </>
    )
}

export default BinTransitKanbanView